<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <UserDataAddressForm
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations" />
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import UserDataAddressForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('userdataaddress/create')

export default {
  components: {
    UserDataAddressForm,
    Loader
  },

  props: {
    userDataIRI: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      routeName: '',
      item: {
        addressType: this.$store.getters['configuration/defaultAddressType']
      }
    }
  },

  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  created () {
    this.routeName = this.$route.name
    if (this.userDataIRI) {
      this.item.idUserData = this.userDataIRI
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$store.state.modals.userdataaddress.create.created = 1
      this.$store.state.modals.userdataaddress.create.close = 1
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
